module.exports = __webpack_public_path__ + "img/2_5_1.ca6d654a.jpg";